import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import AgentRowWithService from './AgentRowWithService';
import AgentQueueRow from './AgentQueueRow';
import Loader from './Components/Loader';
import { getItem, setItem } from '../utils/storage';
import { setServiceAvailabilityCount, getServiceAvailabilityCount, getServiceUnavailabilityCount } from '../utils/utils';
import IncomingCallIcon from '../assets/img/incoming-call.svg';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

class AgentsMonitorWithService extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFilter: '',
			hideMe: getItem('hideMeSettings') == 'true' ? true : false,
			hideOfflineAgents: getItem('hideOfflineSettings') == 'true' ? true : false,
			collapseExpandService: true
		};
	}

	componentDidMount() {
		this.setCollapseSettings()
	}

	componentWillReceiveProps(nextProps) {
		if (JSON.stringify(nextProps.serviceList) !== JSON.stringify(this.props.serviceList)) {
			this.setCollapseSettings(nextProps.serviceList);
		}
	}

	setCollapseSettings = (serviceList = null) => {

		let isCollapsExpand = getItem('isCollapsExpand');
		if (isCollapsExpand != -1) {
			let collapseStatus = (isCollapsExpand == 1) ? true : false;
			this.setState({ collapseExpandService: !collapseStatus });
			this.setServiceCollapse(serviceList ? serviceList : this.props.serviceList, collapseStatus);
		} else {
			let serviceCollapsedList = JSON.parse(getItem('serviceCollapseSetting') || '[]');
			let status = serviceCollapsedList.length > 0 ? false : true;
			this.setState({ collapseExpandService: status }); 
			this.setServiceCollapse(serviceCollapsedList, true);
		}
	}

	setServiceCollapse = (serviceList, value) => {

		(serviceList || []).map(service => {
			this.setState({
				[`hide_service_${service.id || service}`]: value
			});
		});
	}

	getServiceDetails = (user, service) => {
		let serviceDetails = user.availability_detail ? user.availability_detail.find(item => item.service_id == service.id) : {};
		if (!serviceDetails) {
			serviceDetails = {};
		}
		return serviceDetails;
	}

	test = (user, service_id) => {
		let value = false;
		user.availability_detail.forEach(item => {
			if (item.service_id == service_id) {
				value = true;
			}
		});
		return value;
	}

	checkIfAgentService = (user, service_id) => {
		let hasService = false;
		user.availability_detail.forEach(service => {
			if (service.id == service_id) {
				hasService = true;
			}
		});
		return hasService;
	}

	toggleService = (e) => {
		if (e.target.id !== "") { 
			const value = this.state[`hide_service_${e.target.id}`] || false;
			setItem('isCollapsExpand', -1);
			let serviceList = JSON.parse(getItem('serviceCollapseSetting') || '[]');
			let index = serviceList.findIndex(item => item === e.target.id);
	
			if (!value && index === -1) {
				//services closed
				serviceList.push(e.target.id);
				if (serviceList.length < this.props.serviceList.length) {
					this.setState({ collapseExpandService: false });
				}
			} else if (value && index === -1) { 
				this.props.serviceList.forEach((service) => { 
					if (service.id !== e.target.id) { 
						serviceList.push(service.id);
					}
				})
				if (serviceList.length < this.props.serviceList.length) {
					this.setState({ collapseExpandService: false });
				}
			} else if (value && index !== -1) {
				//services opened
				serviceList.splice(index, 1)
				if (serviceList.length === 0) {
					this.setState({ collapseExpandService: true });
				}
			}
			setItem('serviceCollapseSetting', serviceList)
	
			this.setState({
				[`hide_service_${e.target.id}`]: !value
			});
		}
		
	}

	handleCheckboxChange = () => {
		setItem('hideOfflineSettings', !this.state.hideOfflineAgents)

		this.setState({
			hideOfflineAgents: !this.state.hideOfflineAgents
		});
	}

	handleOnHideMeClicked = () => {
		setItem('hideMeSettings', !this.state.hideMe);

		this.setState({
			hideMe: !this.state.hideMe
		});
	}

	handleExpandCollapseService = () => {
		this.setState({ collapseExpandService: !this.state.collapseExpandService });
		this.setServiceCollapse(this.props.serviceList, this.state.collapseExpandService);
		setItem('serviceCollapseSetting', [])
		setItem('isCollapsExpand', this.state.collapseExpandService ? 1 : 0);
	}

	mergeWithService = () => {
		let merge = [];
		this.props.serviceList.forEach(service => {
			service.agents = [];
			this.props.agents.forEach(agent => {
				agent.availability_detail.forEach(list => {
					if (list.service_id == service.id) {
						const agentData = {
							...agent,
							serviceStatus: list.status
						};
						service.agents = [...service.agents, agentData];
					}
				});
			});
			merge = [...merge, service];
		});
		const noService = { name: 'No service', id: 0, agents: [] };
		merge = [...merge, noService];
		return merge;
	}

	getAvailabilityCount = (agentsList, type, service) => {
		let count = 0;
		agentsList.map((agent) => {
			let serviceDetail = this.getServiceDetails(agent, service);
			if (type === 'available' && serviceDetail.status && agent.online) {
				count++;
			} else if (type === 'unavailable' && !serviceDetail.status &&  agent.online) {
				count++;
			}
		});
		return count;
	}

	/*
		groups agents with services. then have them sorted according to name,
		availability, on call status and online.
	 */
	renderList = (mergeWithService, queuedCallsByService) => {
		//const users = [...this.props.agents];

		return this.props.serviceList.map(service => {
			let serviceData = mergeWithService.find(item => item.id == service.id);
			let sortedData = orderBy(serviceData.agents, [user => user.name ? user.name.toLowerCase() : ''], ['asc']);
			sortedData = orderBy(sortedData, 'serviceStatus', 'desc');
			sortedData = orderBy(sortedData, 'online', 'desc');
			sortedData = orderBy(sortedData, 'busy', 'desc');
			//let hasOnline = sortedData.find(agent => agent.online);
			let doFilter = sortedData.filter(agent => agent.name && (agent.online || (!agent.online && !this.state.hideOfflineAgents)) &&
				(agent.name.toLowerCase().includes(this.props.searchFilter.toLowerCase()) || (agent.surname_1 && agent.surname_1.toLowerCase().includes(this.props.searchFilter.toLowerCase())) || 
					agent.extension.includes(this.props.searchFilter)));

			// removed current user if hide me selected
			if (this.state.hideMe) {
				// console.log(this.props.agentInfo, 'agentInfo')
				doFilter = doFilter.filter(agent => agent.extension !== this.props.agentInfo.extension)
			}
			let isService = service.name.toLowerCase().includes(this.props.searchFilter.toLowerCase());
			let availablityCount = this.getAvailabilityCount(doFilter, 'available', service);
			let unavailablityCount = this.getAvailabilityCount(doFilter, 'unavailable', service);
			setServiceAvailabilityCount(service, availablityCount, unavailablityCount);

			// if (doFilter.length > 0) {
			if (doFilter.length > 0 || isService) {
				return (
					<div key={service.id}>
						<div
							id={service.id}
							className={`queueCallRow${this.props.theme} active`}
							style={{ width: '100%', cursor: 'pointer' }}
							onClick={this.toggleService}
						>
							<b id={service.id}>{service.name}</b>
							<div className="status-grp">
								<span>
									<img src={IncomingCallIcon} className={`incoming-call-icon${this.props.theme}`} alt="test"></img>
									{(queuedCallsByService && queuedCallsByService[service.name]) ? queuedCallsByService[service.name].length : 0}
								</span>
								<span style={{ margin: '0 6px' }}>
									<span className="agent-status-row avail-agent-status"></span>
									{availablityCount}
								</span>
								<span><span className="agent-status-row unavail-agent-status"></span>
									{unavailablityCount}
								</span>
							</div>
						</div>
						<Collapse in={!this.state[`hide_service_${service.id}`]}>
							<div>
								<div className={`queueCallRow${this.props.theme}`} style={{ width: '40%' }}>
									<b>{this.props.translations.agents[this.props.selectedLanguage]}</b>
								</div>
								<div className={`queueCallRow${this.props.theme}`} style={{ width: '40%' }}>
									<b>{this.props.translations.state[this.props.selectedLanguage]}</b>
								</div>
								<div className={`queueCallRow${this.props.theme}`} style={{ width: '20%' }}>
									<b>{this.props.translations.time[this.props.selectedLanguage]}</b>
								</div>
								{doFilter.map(user => {
									if (this.getServiceDetails(user, service).service_id) {
										return (
											<AgentRowWithService
												key={user.id}
												user={user}
												type="user"
												serviceDetails={this.getServiceDetails(user, service)}
											/>
										)
									}
								})}
							</div>
						</Collapse>
					</div>
				)
			}
		});
	}

	renderListQueue = (queuedCalls) => (
		Object.keys(queuedCalls).map(type => (
			<div key={type}>
				<div className={`queueCallRow${this.props.theme } active`} style={{ width: '70%' }}>
					<b>{queuedCalls[type][0].service_name}</b>
				</div>
				<div className={`queueCallRow${this.props.theme } active text-right`} style={{ width: '30%' }}>
					<div className="status-grp">
						<span>
							<img src={IncomingCallIcon} className={`incoming-call-icon${this.props.theme }`} alt="test"></img>
							{queuedCalls[type].length}
						</span>
						<span style={{ margin: '0 6px' }}>
							<span className="agent-status-row avail-agent-status"></span>
							{getServiceAvailabilityCount(queuedCalls[type][0].service_id)}
						</span>
						<span><span className="agent-status-row unavail-agent-status"></span>
							{getServiceUnavailabilityCount(queuedCalls[type][0].service_id)}
						</span>
					</div>
				</div>
				<div className={`queueCallRow${this.props.theme }`} style={{ width: '35%' }}>
					<b>{this.props.translations.phoneNumber[this.props.selectedLanguage]}</b>
				</div>
				<div className={`queueCallRow${this.props.theme }`} style={{ width: '35%' }}>
					<b>{this.props.translations.ring[this.props.selectedLanguage]}</b>
				</div>
				<div className={`queueCallRow${this.props.theme }`} style={{ width: '30%' }}>
					<b>{this.props.translations.onQueue[this.props.selectedLanguage]}</b>
				</div>
				{queuedCalls[type].map(item => (
					<AgentQueueRow
						key={item.linkedid}
						item={item}
					/>
				))}
			</div>
		))
	)
	render() {
		const {
			agents,
			queuedCalls,
			agentsLoadComplete,
			translations,
			selectedLanguage
		} = this.props;
		let { collapseExpandService } = this.state;

		const queuedCallsByService = mapValues(groupBy(queuedCalls, 'service_name'));
		const mergeWithService = this.mergeWithService();
		let listToRender = this.renderList(mergeWithService, queuedCallsByService);
		let isServiceExisitInList = listToRender.every(service => service);

		return (
			<div className={`container-fluid${this.props.theme}`} style={{ overflow: 'hidden' }}>
				<div className="row">
					<div className="col-md-6">
						<div className="row">
							<div className="col-md-12">
								<h4 className={`divtext${this.props.theme}`}>{translations.callsInQueue[selectedLanguage]}</h4>
								<div className="table-responsive">
									<table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
										<thead>
											<tr>
												<th />
												<th />
												<th />
											</tr>
										</thead>
										<div style={{ height: 'calc(-117px + 100vh)', overflow: 'auto' }}>
											{this.renderListQueue(queuedCallsByService)}
											{queuedCalls.length == 0 &&
												<div className={`panel-body${this.props.theme} text-center small`}>
													{!agentsLoadComplete && <span style={{ fontSize: 12 }}>{translations.noCallsInQueue[selectedLanguage]}</span>}
													{agentsLoadComplete && <span style={{ fontSize: 12 }}>{translations.noQueuedCallsNow[selectedLanguage]}</span>}
												</div>
											}
										</div>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6" style={{ height: 'calc(100vh - 66px)' }}>
						<div className={`checkbox-container${this.props.theme }`}>
							<div className="checkbox checkbox-style">
								<label className="control control--checkbox checkbox-label">{translations.hideMeText[selectedLanguage]}
									<input
										type="checkbox"
										checked={this.state.hideMe}
										onChange={this.handleOnHideMeClicked}
									/>
									<div className="control__indicator" />
								</label>
							</div>
							<div className="checkbox checkbox-style">
								<label className="control control--checkbox checkbox-label">{translations.hideOfflineAgents[selectedLanguage]}
									<input
										type="checkbox"
										checked={this.state.hideOfflineAgents}
										onChange={this.handleCheckboxChange}
									/>
									<div className="control__indicator" />
								</label>
							</div>
							<div className="checkbox checkbox-style">
								{collapseExpandService && <button className="expand-collapse-btn" onClick={this.handleExpandCollapseService}>
									{translations.collapseAllText[selectedLanguage]}</button>}
								{!collapseExpandService && <button className="expand-collapse-btn" onClick={this.handleExpandCollapseService}>
									{translations.expandAllText[selectedLanguage]}</button>}
							</div>
						</div>
						<div style={{ height: 'calc(100% - 25px)' }}>
							<div style={{ fontSize: 18, padding: '5px 0px'}} className={`divtext${this.props.theme}`}>{translations.services[selectedLanguage]}</div>
							<div className="table-responsive">
								<table className={`table-fixed table table${this.props.theme } table-condensed table-hover${this.props.theme } small m-a-0`}>
									<div style={{ height: 'calc(100vh - 135px)', overflow: 'auto' }}>
										{agents.length > 0 && listToRender}
										{agents.length == 0 && <div>
											{!agentsLoadComplete && <Loader width="20px" height="20px" />}
											{agentsLoadComplete && <p>{translations.noServiceToSupervise[selectedLanguage]}</p>}
										</div>}
										{!isServiceExisitInList && <div className="no-service-txt">{translations.noServiceFound[selectedLanguage]}</div>}
									</div>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		agents: state.agentsAndSupervisors.agents,
		agentsLoadComplete: state.agentsAndSupervisors.agentsLoadComplete,
		supervisors: state.agentsAndSupervisors.supervisors,
		serviceList: state.agentsAndSupervisors.serviceList,
		agentInfo: state.agentInfo,
		queuedCalls: state.queuedCalls.queuedCalls,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
	};
}

export default connect(mapStateToProps)(AgentsMonitorWithService);



// WEBPACK FOOTER //
// ./src/agent/AgentsMonitorWithService.js